import {isEmpty} from 'lodash-es';

const registrationPage = {
    strict: true,
    namespaced: true,
    state: {
        customerInfo: null,
        countryOptions: null,
        phoneIndicatives: [],
        // forms data
        descriptionForm: [],
        recipeForm: [],
        // media grid -> image and video upload / registration
        mediaGridUpload: [],
        selectedProductsList: [], // catalog products selected 
        productCategories: [],
        productList: [],
        notificationData: null,
        forceHideEditButtons: false,
        blockThumbnail: null
    },
    mutations: {
        customerInfo(state, payload) {
            state.customerInfo = Object.assign({}, state.customerInfo, payload);
        },
        countryOptions(state, payload) {
            let parsedCountries = [];
            if(!isEmpty(payload)) {
                payload.forEach((element, index) => {
                    parsedCountries.push({
                        id: element.code,
                        text: element.name,
                        value: element.code,
                    });
                });
            }
            state.countryOptions = parsedCountries;
        },
        phoneIndicatives(state, payload) {
            state.phoneIndicatives = payload;
        },
        descriptionForm(state, payload) {
            state.descriptionForm = payload;
        },
        recipeForm(state, payload) {
            state.recipeForm = payload;
        },
        mediaGridUpload(state, payload) {
            let position = payload?.position ?? 1;
            let grid     = state.mediaGridUpload.filter(elm => elm?.position != position);
            if(payload?.mediaData?.src) {
                grid.splice(payload.position, 0, {
                    position: payload.position,
                    type: payload.type,
                    mediaData: payload.mediaData
                });
            }
            state.mediaGridUpload = grid;
        },
        selectedProductsList(state, payload) {
            // set payload ensuring it's and array
            state.selectedProductsList = Array.isArray(payload) ? payload : [];
        }, 
        addSelectedProduct(state, payload) {
            state.selectedProductsList.push(payload);
        }, 
        removeSelectedProduct(state, payload) {
            state.selectedProductsList = state.selectedProductsList.filter(item => item.groupId != payload.groupId);
        }, 
        productList(state, payload) {
            if(payload.page === 1){
                state.productList = payload.products;
            }
            else{
                state.productList = state.productList.concat(payload.products);
            }
        }, 
        productCategories(state, payload) {
            state.productCategories = payload;
        },
        notificationData(state, payload) {
            state.notificationData = payload;
        },
        forceHideEditButtons(state, payload) {
            state.forceHideEditButtons = payload;
        },
        blockThumbnail(state, payload) {
            state.blockThumbnail = payload;
        },
    },
    actions: {
        setWsData(context, payload, rootState) {
            if (!isEmpty(payload)) {
                context.dispatch('setWsData', payload, {root: true});
                context.commit('customerInfo', payload.wsData.customerInfo);
                context.commit('countryOptions',
                    payload.wsData.pastimeInfo.countries);
                context.commit('phoneIndicatives',
                    payload.wsData.pastimeInfo.phoneIndicatives);
                let layoutSize = payload.wsData.pastimeInfo.detailedInfo.mediaLayoutSize;
                if (layoutSize) {
                    let i = 0;
                    for (i; i < layoutSize; i++) {
                        let pastimeId = payload.wsData.pastimeInfo.baseInfo.id;
                        let customerId = context.getters.customerInfo.info.customer_id;
                        let position = i + 1;
                        let imageId = pastimeId + '-' + customerId + '-pos-' + position;
                        let defaultGridSection = {
                            position: position,
                            type: 'image',
                            mediaData: {
                                src: '',
                                alt: imageId,
                                file: null,
                            },
                        };

                        // for now only 1 video (no mix mode)
                        let videoUpload = layoutSize == 1 && payload.wsData.pastimeInfo.baseInfo.layoutType == 'ONEVIDEO';
                        if (videoUpload) {
                            defaultGridSection = {
                                position: position,
                                type: 'video',
                                mediaData: {
                                    src: '',
                                    thumbnail: '',
                                    file: null,
                                },
                            };
                        }
                        context.commit('mediaGridUpload', defaultGridSection);
                    }
                }
            }
        },
        setCustomerInfo(context, payload) {
            context.commit('customerInfo', payload);
        },
        setCountryOptions(context, payload) {
            context.commit('countryOptions', payload);
        },
        setPhoneIndicatives(context, payload) {
            context.commit('phoneIndicatives', payload);
        },
        setRecentBlock(context, payload) {
            context.commit('recentBlock', payload);
        },
        setDescriptionForm(context, payload) {
            context.commit('descriptionForm', payload);
        },
        setRecipeForm(context, payload) {
            context.commit('recipeForm', payload);
        },
        setMediaGridUpload(context, payload) {
            context.commit('mediaGridUpload', payload);
        },
        setProductCategories(context, payload) {
            context.commit('productCategories', payload);
        },
        setSelectedProductsList(context, payload) {
            context.commit('selectedProductsList', payload);
        },
        addSelectedProducts(context, payload) {
            context.commit('addSelectedProduct', payload);
        },
        removeSelectedProducts(context, payload) {
            context.commit('removeSelectedProduct', payload);
        },
        setProductListData(context, payload) {
            if(!payload.products){
                payload = {page:1, products: []};
            }
            context.commit('productList', payload);
        },
        loadNotification(context, payload) {
            context.commit('notificationData', payload);
            setTimeout(() => {
                context.commit('notificationData', null);
            }, typeof payload.duration !== 'undefined' ? payload.duration : 4000);
        },
        setForceHideEditButtons(context, payload) {
            context.commit('forceHideEditButtons', payload);
        },
        setBlockThumbnail(context, payload) {
            context.commit('blockThumbnail', payload);
        },
    },
    getters: {
        customerInfo: state => state.customerInfo,
        countryOptions: state => state.countryOptions,
        phoneIndicatives: state => state.phoneIndicatives,
        descriptionForm: state => state.descriptionForm,
        recipeForm: state => state.recipeForm,
        mediaGridUpload: state => state.mediaGridUpload,
        selectedProductsList: state => state.selectedProductsList,
        productList: state => state.productList,
        productCategories: state => state.productCategories,
        notificationData: state => state.notificationData,
        forceHideEditButtons: state => state.forceHideEditButtons,
        blockThumbnail: state => state.blockThumbnail,
    },
};

export default registrationPage;